/**
 * Lottery Odds Configuration
 * Centralized odds data for all active lotteries
 * 
 * Format: "1 in X" only - no percentages
 * Uses official bonus names for each lottery
 */

export const LOTTERY_ODDS = {
  swisslotto: {
    name: "Swiss Lotto",
    bonusName: "Lucky Number",
    tiers: [
      { match: "6 + Lucky Number", odds: "1 in 31,474,716" },
      { match: "6", odds: "1 in 6,294,943" },
      { match: "5 + Lucky Number", odds: "1 in 145,716" },
      { match: "5", odds: "1 in 29,143" },
      { match: "4 + Lucky Number", odds: "1 in 4,608" },
      { match: "4", odds: "1 in 922" },
      { match: "3 + Lucky Number", odds: "1 in 188" },
      { match: "3", odds: "1 in 38" },
    ],
  },

  euromillions: {
    name: "EuroMillions",
    bonusName: "Lucky Stars",
    tiers: [
      { match: "5 + 2 Lucky Stars", odds: "1 in 139,838,160" },
      { match: "5 + 1 Lucky Star", odds: "1 in 6,991,908" },
      { match: "5", odds: "1 in 3,107,515" },
      { match: "4 + 2 Lucky Stars", odds: "1 in 621,503" },
      { match: "4 + 1 Lucky Star", odds: "1 in 31,075" },
      { match: "4", odds: "1 in 13,811" },
      { match: "3 + 2 Lucky Stars", odds: "1 in 14,125" },
      { match: "3 + 1 Lucky Star", odds: "1 in 706" },
      { match: "3", odds: "1 in 314" },
      { match: "2 + 2 Lucky Stars", odds: "1 in 985" },
      { match: "2 + 1 Lucky Star", odds: "1 in 49" },
      { match: "1 + 2 Lucky Stars", odds: "1 in 188" },
    ],
  },

  eurodreams: {
    name: "EuroDreams",
    bonusName: "Dream Number",
    tiers: [
      { match: "6 + Dream Number", odds: "1 in 19,191,900" },
      { match: "6", odds: "1 in 4,797,975" },
      { match: "5 + Dream Number", odds: "1 in 282,234" },
      { match: "5", odds: "1 in 70,559" },
      { match: "4 + Dream Number", odds: "1 in 8,819" },
      { match: "4", odds: "1 in 2,205" },
      { match: "3 + Dream Number", odds: "1 in 504" },
      { match: "3", odds: "1 in 126" },
      { match: "2 + Dream Number", odds: "1 in 56" },
      { match: "1 + Dream Number", odds: "1 in 22" },
    ],
  },

  superenalotto: {
    name: "SuperEnalotto",
    bonusName: "Jolly",
    tiers: [
      { match: "6", odds: "1 in 622,614,630" },
      { match: "5 + Jolly", odds: "1 in 103,769,105" },
      { match: "5", odds: "1 in 1,250,230" },
      { match: "4", odds: "1 in 11,907" },
      { match: "3", odds: "1 in 327" },
      { match: "2", odds: "1 in 22" },
    ],
  },

  laprimitiva: {
    name: "La Primitiva",
    bonusName: "Reintegro",
    tiers: [
      { match: "6 + Reintegro", odds: "1 in 139,838,160" },
      { match: "6", odds: "1 in 13,983,816" },
      { match: "5 + Complementario", odds: "1 in 2,330,636" },
      { match: "5", odds: "1 in 54,201" },
      { match: "4", odds: "1 in 1,032" },
      { match: "3", odds: "1 in 57" },
      { match: "Reintegro", odds: "1 in 10" },
    ],
  },

  eurojackpot: {
    name: "EuroJackpot",
    bonusName: "Euro Numbers",
    tiers: [
      { match: "5 + 2 Euro Numbers", odds: "1 in 139,838,160" },
      { match: "5 + 1 Euro Number", odds: "1 in 6,991,908" },
      { match: "5", odds: "1 in 3,107,515" },
      { match: "4 + 2 Euro Numbers", odds: "1 in 621,503" },
      { match: "4 + 1 Euro Number", odds: "1 in 31,075" },
      { match: "4", odds: "1 in 13,811" },
      { match: "3 + 2 Euro Numbers", odds: "1 in 14,125" },
      { match: "3 + 1 Euro Number", odds: "1 in 706" },
      { match: "2 + 2 Euro Numbers", odds: "1 in 985" },
      { match: "3", odds: "1 in 314" },
      { match: "1 + 2 Euro Numbers", odds: "1 in 188" },
      { match: "2 + 1 Euro Number", odds: "1 in 49" },
    ],
  },

  megamillions: {
    name: "Mega Millions",
    bonusName: "Mega Ball",
    tiers: [
      { match: "5 + Mega Ball", odds: "1 in 302,575,350" },
      { match: "5", odds: "1 in 12,607,306" },
      { match: "4 + Mega Ball", odds: "1 in 931,001" },
      { match: "4", odds: "1 in 38,792" },
      { match: "3 + Mega Ball", odds: "1 in 14,547" },
      { match: "3", odds: "1 in 606" },
      { match: "2 + Mega Ball", odds: "1 in 693" },
      { match: "1 + Mega Ball", odds: "1 in 89" },
      { match: "Mega Ball only", odds: "1 in 37" },
    ],
  },

  powerball: {
    name: "Powerball",
    bonusName: "Powerball",
    tiers: [
      { match: "5 + Powerball", odds: "1 in 292,201,338" },
      { match: "5", odds: "1 in 11,688,054" },
      { match: "4 + Powerball", odds: "1 in 913,129" },
      { match: "4", odds: "1 in 36,525" },
      { match: "3 + Powerball", odds: "1 in 14,494" },
      { match: "3", odds: "1 in 580" },
      { match: "2 + Powerball", odds: "1 in 701" },
      { match: "1 + Powerball", odds: "1 in 92" },
      { match: "Powerball only", odds: "1 in 38" },
    ],
  },

  megasena: {
    name: "Mega-Sena",
    bonusName: null, // Mega-Sena has no bonus ball
    tiers: [
      { match: "6 (Sena)", odds: "1 in 50,063,860" },
      { match: "5 (Quina)", odds: "1 in 154,518" },
      { match: "4 (Quadra)", odds: "1 in 2,332" },
    ],
  },

  "uk-lotto": {
    name: "UK Lotto",
    bonusName: "Bonus Ball",
    tiers: [
      { match: "6 + Bonus Ball", odds: "1 in 45,057,474" },
      { match: "6", odds: "1 in 7,509,579" },
      { match: "5 + Bonus Ball", odds: "1 in 144,415" },
      { match: "5", odds: "1 in 24,069" },
      { match: "4 + Bonus Ball", odds: "1 in 2,180" },
      { match: "4", odds: "1 in 363" },
      { match: "3 + Bonus Ball", odds: "1 in 96" },
      { match: "3", odds: "1 in 16" },
      { match: "2 + Bonus Ball", odds: "1 in 32" },
    ],
  },

  "australian-lotto": {
    name: "Australian Lotto (Saturday Lotto)",
    bonusName: "Supplementary",
    tiers: [
      { match: "6 (Division 1)", odds: "1 in 8,145,060" },
      { match: "5 + 1 Supp", odds: "1 in 678,755" },
      { match: "5", odds: "1 in 36,689" },
      { match: "4", odds: "1 in 733" },
      { match: "3 + 1 Supp", odds: "1 in 297" },
      { match: "2 + 2 Supp", odds: "1 in 144" },
      { match: "3", odds: "1 in 55" },
    ],
  },
};

export default LOTTERY_ODDS;
